export class HtmlBuilder {
  constructor(ids, classes, content) {
    this.ids = ids
    this.classes = classes
    this.content = content
  }

  build() {
    return `<div
      id="${this.ids.containerId}"
      class="${this.classes.classes}"
    >
      <i
        id="${this.ids.id}"
        class="${this.getIconClasses()}"
      />
    </div>`
  }

  getIconClasses() {
    return `${this.content.class} ${this.content.icon} ${this.classes.iconClasses}`
  }
}
